import { CsvOptions } from '@app/core/services/csv.service';

/**
 * Triggers a download from a Blob, with fallbacks for iOS/Safari.
 * Optionally prepends a UTF-8 BOM for Excel friendliness.
 */
export function downloadBlobAsFile(
  blob: Blob,
  filename: string,
  options?: CsvOptions,
) {
  const needsType = !blob.type;
  const baseType = 'text/csv;charset=utf-8';
  const typedBlob = needsType ? new Blob([blob], { type: baseType }) : blob;

  const finalBlob =
    options?.utf8Bom
      ? new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), typedBlob], {
        type: typedBlob.type || baseType,
      })
      : typedBlob;

  const url = URL.createObjectURL(finalBlob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;

  // If the browser supports the download attribute, use it; otherwise open in a new tab (iOS/Safari).
  const supportsDownloadAttr = 'download' in HTMLAnchorElement.prototype;

  if (supportsDownloadAttr) {
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke ASAP but after click
    setTimeout(() => URL.revokeObjectURL(url), 0);
  } else {
    // iOS/Safari fallback
    window.open(url, '_blank');
    // Revoke a bit later to ensure the new window can read it
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
